import React, { useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import { Avatar, Box, Card, Chip, Divider, Grid, Typography } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { assignedClasses } from '../../../../Utils/apiService';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router-dom';
import routes from '../../../../Utils/routes';
import KenLoader from '../../../../GlobalComponents/KenLoader';
import { getUserDetails } from '../../../../storageService';

const useStyles = makeStyles(() => ({
    root: {
        backgroundColor: '#f5f5f5',
        maxHeight: '80vh !important',
        overflow: 'hidden',
    },
    leftPanel: {
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '8px',
        textAlign: 'left',
        height: '100vh',
        overflowY: 'hidden',
    },
    rightPanel: {
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '8px',
        textAlign: 'left',
        height: '100vh',
        overflowY: 'hidden',
    },
    leftPanelCard: {
        borderRadius: '12px !important',
        background: 'var(--colors-secondary-white, #FFF) !important',
        boxShadow: '0px 0px 30px 0px rgba(148, 173, 255, 0.10) !important',
        padding: '20px !important', // optional: to make it look nice
        width: '100%',
    },
    leftPanelCard1: {
        borderRadius: '12px !important',
        // background: 'var(--colors-secondary-white, #F6F8FB) !important',
        boxShadow: '0px 0px 30px 0px rgba(148, 173, 255, 0.10) !important',
        padding: '20px !important', // optional: to make it look nice
        width: '100%',
    },

    Grade: {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '14px',
        color: "#585A64"
    }
}));

const ParentTeacherView = () => {
    const classes = useStyles()
    const [parentClassesArray, setParentClassesArray] = React.useState<any[]>([]);
    const [loading, setLoading] = React.useState<boolean>(false);
    const navigate = useNavigate();

    const userDetails = getUserDetails();
    const userType = userDetails?.Type || '';
    const contactId = userDetails?.ContactId || '';

    function formatWeekRange(dateStr: string): string {
        const date = new Date(dateStr);
        const day = date.getDay(); // 0 (Sun) to 6 (Sat)

        // Get the Sunday of the current week
        const sunday = new Date(date);
        sunday.setDate(date.getDate() - day);

        // Get the Saturday of the current week
        const saturday = new Date(sunday);
        saturday.setDate(sunday.getDate() + 6);

        const options: Intl.DateTimeFormatOptions = { month: 'long', day: 'numeric' };

        const formattedStart = sunday.toLocaleDateString('en-US', options); // e.g., July 12
        const formattedEnd = saturday.getDate(); // just day number
        const year = date.getFullYear();

        return `${formattedStart} - ${formattedEnd}, ${year}`;
    }

    useEffect(() => {
        // Any side effects or data fetching can be done here
        // const user = getUserDetails();

        setLoading(true);
        assignedClasses(contactId).then((res) => {
            setLoading(false);
            let response = res.data;
            console.log('Temp Array:', response);
            let assignedClassesArray = response?.assignedClasses?.map((item: any, index: number) => {
                return {
                    className: item.courseOffering?.Name,
                    grade: item.courseOffering?.Program_Plan__r?.hed__Account__r?.Name,
                    studentCount: item.studentCount,
                    room: item?.courseOffering?.Type__c,
                    url: item?.courseOffering?.Id
                };
            });

            let ParentTeacherConference = response?.ptcList?.map((item: any, index: number) => {
                return {
                    className: item?.Name,
                    grade: item?.Program_Plan__r?.Name,
                    room: item?.Status__c,
                    date: item?.Start_Date__c,
                    Status: item?.Status__c,
                    Id: item?.Id
                };
            });
            setParentClassesArray(ParentTeacherConference);
            console.log('Assigned Classes Array:', assignedClassesArray);
            // You can set the state with the response data if needed
        }).catch((error) => {
            setLoading(false);
            console.error('Error fetching assigned classes:', error);
        });
    }, []);

    return (
        <div className='text-start'>
            {
                loading && <KenLoader />
            }
            <Typography >Parent Teacher Conferences</Typography>
            <Divider className='my-4' />
            <Grid container spacing={2}>
                {
                    parentClassesArray.map((item, index) => {
                        const isUpcoming = item.room === 'Upcoming';

                        return <Grid item xs={12} md={3} sm={6} key={index} onClick={() => {
                            if (!isUpcoming) navigate(`${routes.ParentTeacherConference}/${item.Id}`);
                        }}
                            style={{ cursor: isUpcoming ? 'not-allowed' : 'pointer' }}>
                            <Card className={classes.leftPanelCard1} sx={{ background: item?.room === 'Upcoming' ? "#D9DBE1" : "#F6F8FB" }}>
                                <div className='d-flex justify-content-between align-items-center '>
                                    <Typography>
                                        {item.className}
                                    </Typography>
                                    {
                                        item.room === 'Upcoming' ? (
                                            <Chip label={item.room} style={{ height: 24, padding: '3px 6px', fontSize: 12, color: '#585A64' }} />

                                        ) : item.room === 'Completed' ? (
                                            <Chip label={item.room} style={{ height: 24, padding: '3px 6px', fontSize: 12, color: '#585A64', background: "#C1DCC3" }} />

                                        ) : (
                                            <Chip label={item.room} style={{ height: 24, padding: '3px 6px', fontSize: 12, color: '#585A64', background: "#FEEBBE" }} />
                                        )
                                    }
                                </div>
                                <Typography>
                                    {item.grade}
                                </Typography>
                                <div className='d-flex justify-content-between align-items-end mt-3'>
                                    <div className='d-flex gap-2'>
                                        <CalendarTodayIcon sx={{ color: '#585A64', height: 20, width: 20 }} />
                                        <Typography className={classes.Grade}>
                                            {formatWeekRange(item?.date)}
                                        </Typography>
                                    </div>
                                    <ArrowForwardIcon />
                                </div>
                            </Card>
                        </Grid>
                    })
                }
            </Grid>
        </div>
    )
}

export default ParentTeacherView